import { observer } from "mobx-react-lite";
import React from "react";
import ReactDataGrid,  {Column} from "react-data-grid";

interface AuditProp {
    children?: JSX.Element;
    columns: any[];
    rows:any[]
}


export const Audit = observer((props: AuditProp) => {
    return (
        <>
            <ReactDataGrid className="grid-child-container" columns={props.columns} rows={props.rows} />
            {props.children}
        </>
        
    );
});
